var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { StorageService } from '@/infrastructure/utils/util-services/local-storage/type/local-storage-service.interface';
import { SPACE_LIST_DEFAULT_COLUMNS } from '../constants';
const LOCAL_STORAGE_VISIBLE_FIELDS_KEY = 'LOCAL_STORAGE_VISIBLE_FIELDS_KEY';
let SpaceFieldServiceImpl = class SpaceFieldServiceImpl {
    constructor(_storageService) {
        this._storageService = _storageService;
    }
    getVisibleFields() {
        const visibleFields = this._storageService.getItem(LOCAL_STORAGE_VISIBLE_FIELDS_KEY) || SPACE_LIST_DEFAULT_COLUMNS;
        return visibleFields;
    }
    setVisibleFields(fields) {
        this._storageService.setItem(LOCAL_STORAGE_VISIBLE_FIELDS_KEY, fields);
    }
};
SpaceFieldServiceImpl = __decorate([
    injectable(),
    __param(0, inject(StorageService)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService !== "undefined" && StorageService) === "function" ? _a : Object])
], SpaceFieldServiceImpl);
export { SpaceFieldServiceImpl };
